import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        licence: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'licence.Licence period' | translate }}</h2>
        </div>
        <div class="modal-body">
            <div class="form">
                <manage-settings-licences-periods-form form="vm.form"/>
            </div>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary"><button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button></li>
                <li><button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()">{{ 'general.Cancel' | translate }}</button></li>
            </ul>
        </div>
    `
})
export default class {
    constructor (FormFactory, LicencePeriodResource) {
        this.form = FormFactory.createFromResource(new LicencePeriodResource());
        this.form.model.licenceId = this.licence.id;
    }

    save () {
        this.form.save().then((licencePeriod) => this.uibModalInstance.close(licencePeriod));
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/manage/licences/edit/periods/add/index.js